export default "__VITE_ASSET__1znMhuN1__"